var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(_vm.$vuetify.breakpoint.xsOnly)?_c('DrawerNav'):_vm._e(),_vm._v(" "),(_vm.$vuetify.breakpoint.smAndUp)?_c('AppBarNav'):_vm._e(),_vm._v(" "),_c('v-main',[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }